@if (isPageLoaded()) {
  @let metadata = lineupsMetadata();
  <lib-page-layout>
    <lib-title-navbar
      pageHeader
      title="Zobacz składy"
      [showRandomize]="metadata?.isHost ?? false"
      (onRandomizeClicked)="shufflePlayers()"></lib-title-navbar>

    @if (metadata?.isSaved || shouldShowLineups()) {
      <div class="or-px-16-px or-pt-20-px">
        <ion-reorder-group (ionItemReorder)="doReorder($event)" [disabled]="!metadata?.isHost">
          @for (player of players(); track player.playerId; let i = $index) {
            <div>
              @if (i === 0) {
                <div class="or-head-xs or-color-secondary-2">Skład 1</div>
              }
              @if (i === splitTeamSize()) {
                <div class="or-head-xs or-color-secondary-2">Skład 2</div>
              }
              <div
                class="or-d-flex or-align-items-center or-justify-content-between or-py-8-px lineups-border"
                [class.or-mb-32-px]="i === splitTeamSize() - 1">
                <div class="or-d-flex or-align-items-center">
                  <lib-or-avatar
                    [avatarUrl]="player.userThumbnail"
                    [initials]="player.userDisplayName"
                    [avatarSize]="'sm'"></lib-or-avatar>

                  <div>
                    <div class="or-head-sm or-d-flex or-align-items-center" [class.or-opacity-70]="!player.userId">
                      <div>{{ player.userDisplayName }}</div>
                      @if (player.preferredPosition === 'GOALKEEPER') {
                        <or-icon name="gk" size="m" class="or-ml-8-px" />
                      }
                    </div>

                    @if (player?.preferredLevel || player?.preferredPosition) {
                      <div class="or-note-sm or-color-secondary-2">
                        @if (player.preferredPosition) {
                          {{ preferredPositionMapper[player.preferredPosition] }}
                        }
                        @if (player.preferredLevel) {
                          {{ gameLevelMapper[player.preferredLevel] }}
                        }
                      </div>
                    }
                  </div>
                </div>

                <ion-reorder slot="end">
                  <or-icon name="dots-vertical" size="s" />
                  <or-icon name="dots-vertical" size="s" class="dots-margin" />
                </ion-reorder>
              </div>
            </div>
          }
        </ion-reorder-group>
      </div>
    } @else {
      <div class="or-d-flex or-flex-col or-align-items-center or-px-16-px or-h-100-pc or-justify-content-center">
        <img src="assets/lineups-illustration.svg" />
        @if (metadata?.isHost) {
          <div class="or-text-align-center or-head-md">Wylosuj składy na następną gierkę!</div>
          <div class="or-text-align-center or-text-lg or-color-secondary-2">
            Kliknij w prawym górnym rogu na ikonkę losowania, by wyznaczyć składy na gierkę.
          </div>

          <button (click)="shufflePlayers()" class="button-primary-style or-h-48-px or-w-50-pc or-head-md or-mt-32-px">
            Losuj!
          </button>
        } @else {
          <div class="or-text-align-center or-head-md">Składy nie zostały jeszcze wylosowane.</div>
        }
      </div>
    }

    <lib-page-actions pageActions>
      @if (metadata?.isHost && (metadata?.isSaved || shouldShowLineups())) {
        <button (click)="save()" class="button-primary-style or-h-48-px or-head-md or-w-100-pc">Zapisz składy!</button>
      }
    </lib-page-actions>
  </lib-page-layout>
}
